/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO(value) {
    if (!('SaveTokenUrl' in value) || value['SaveTokenUrl'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SaveTokenUrl': json['SaveTokenUrl'],
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SaveTokenUrl': value['SaveTokenUrl'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO.js.map